import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {},
    icon: {
      display: 'inline-block',
      verticalAlign: 'middle',
      img: {
        display: 'block',
      },
    },
    label: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginLeft: 8,
      color: theme.colors.gray[6],
      textTransform: 'uppercase',
    },
  }
})
